<template>
  <div
    ref="swiperContainer"
    class="swiper-container mb-4 pb-1"
  >
    <div class="swiper-wrapper">
      <slot />
    </div>

    <span class="swiper-button-prev" />
    <span class="swiper-button-next" />
  </div>
</template>

<script>
import Swiper, { Navigation } from 'swiper';

import 'swiper/swiper-bundle.css';

Swiper.use([Navigation]);

export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    this.swiper = new Swiper(this.$refs.swiperContainer, {
      ...this.options,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  },

  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  },
};
</script>

<style scoped>
.swiper-button-next {
  right: 2px;
}

.swiper-button-prev {
  left: 2px;
}

.swiper-button-next,
.swiper-button-prev {
  width: 28px;
  height: 38px;
  background: var(--bs-primary);
  border-radius: 5px;
  color: #fff;
}

.swiper-button-next::after,
.swiper-button-prev::after {
  font-size: 25px;
}
</style>